import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    NonZeroNumberColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Receiving mailbox', 'receivingMailbox'),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId')
          .withWidth(255)),
        new DateColumn('Despatch closed', 'despatchCloseDate')
          .withWidth(150),
        new NonZeroNumberColumn('Despatch serial number', 'despatchSerialNumber'),
        new NonZeroNumberColumn('Next despatch serial number', 'nextDespatchSerialNumber'),
        new NonZeroNumberColumn('Prev serial number from next', 'prevSerialNumberFromNext'),
        new NonZeroNumberColumn('Numbers missed', 'numbersMissed'),
      ],
    },
  ];
};
